import WebLayout from './ProgressBarLayout.web';
import MobileLayout from './ProgressBarLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
